import { InputField } from "@ps-design-system/components/Input";

import { useIntl } from "react-intl-compat";

const ListingTitleField = () => {
  const intl = useIntl();

  return (
    <InputField
      fullWidth
      name="title"
      label={intl.formatMessage({
        id: "hosting.listing_details.title_label",
        defaultMessage: "Title",
      })}
      required
      testId="listing-details-form-title-input"
    />
  );
};

export { ListingTitleField };
